import { ChangeDetectionStrategy, Component, computed, inject, input, Input } from '@angular/core';

import { FormlyFieldConfig } from '@ngx-formly/core';
import { MatError } from '@angular/material/form-field';
import { FormlyErrorService } from '../services/formly.service';

@Component({
  selector: 'app-formly-error',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatError],
  template: `
    @if (showError()) {
      <mat-error
        class="px-4 text-sm mb-4"
        data-cy="formly-error"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        >{{ this.formlyErrorService.getErrorMessage(this.field()) }}</mat-error
      >
    }
  `,
})
export class FormlyErrorComponent {
  field = input.required<FormlyFieldConfig>();
  showError = computed(() => {
    return this.field().formControl?.errors && (this.field().formControl.touched || this.field().formControl.dirty);
  });
  formlyErrorService = inject(FormlyErrorService);
}
